"use client";

import { useEffect, type JSX } from "react";
import { LoadingSpinner } from "shared-components";

import type { DefaultComponentProps } from "@/interfaces/common";
import { useAuthStore } from "@/stores/use-auth-store";
import { useUserStore } from "@/stores/use-user-store";

export const WithStore = ({ children }: DefaultComponentProps): JSX.Element => {
  const loadUserData = useUserStore((state) => state.loadUserData);
  const hasInitializedUser = useUserStore((state) => state.hasInitializedUser);
  const hasCheckedAuth = useAuthStore((state) => state.hasCheckedAuth);

  useEffect(() => {
    if (!hasInitializedUser && hasCheckedAuth) {
      loadUserData().catch((error) => {
        console.error("Failed to load user data:", error);
      });
    }
  }, [hasInitializedUser, hasCheckedAuth, loadUserData]);

  if (!hasInitializedUser) {
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  return <>{children}</>;
};
